import {
  ActionType,
  createReducer,
  createStandardAction,
  StateType
} from "typesafe-actions";

type DeviceLogsActionType =
  | "START_FETCHING"
  | "STOP_FETCHING"
  | "UPDATE_LOG_INFO";

export const startFetching = createStandardAction<DeviceLogsActionType>(
  "START_FETCHING"
)<{
  deviceId: string;
}>();
export const stopFetching = createStandardAction<DeviceLogsActionType>(
  "STOP_FETCHING"
)<{
  deviceId: string;
}>();
export const updateLogInfo = createStandardAction<DeviceLogsActionType>(
  "UPDATE_LOG_INFO"
)<
  {
    deviceId: string;
  } & Pick<LogState, "downloadLink" | "uploadedOn">
>();

const DeviceLogsActions = { startFetching, stopFetching, updateLogInfo };
export type DeviceLogsAction = ActionType<typeof DeviceLogsActions>;

type LogState = {
  fetching: boolean;
  downloadLink: string;
  uploadedOn: string;
  lastUploadRequestTime: string;
};

type LogsState = {
  [deviceId: string]: LogState;
};

const defaultDeviceLogsState: LogsState = {};

export const DeviceLogsReducer = createReducer(defaultDeviceLogsState)
  .handleAction(startFetching, (state, { payload }) => ({
    ...state,
    [payload.deviceId]: {
      ...state[payload.deviceId],
      fetching: true,
      lastUploadRequestTime: new Date().toISOString()
    }
  }))
  .handleAction(stopFetching, (state, { payload }) => ({
    ...state,
    [payload.deviceId]: {
      ...state[payload.deviceId],
      fetching: false
    }
  }))
  .handleAction(updateLogInfo, (state, { payload }) => ({
    ...state,
    [payload.deviceId]: {
      ...state[payload.deviceId],
      downloadLink: payload.downloadLink,
      uploadedOn: payload.uploadedOn
    }
  }));

export type DeviceLogsState = StateType<typeof DeviceLogsReducer>;
